(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Shoppable-Video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xwp-live-collection"]) return;
  try {
    
(()=>{
  const normalise=value=>String(value||'').normalize('NFKD').toLowerCase();
  const escape=value=>String(value??'').replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#39;');
  function start(root){
    if(root.dataset.xcfReady)return;
    root.dataset.xcfReady='true';
    const sort=root.querySelector('[data-xcf-sort]'),sortForm=root.querySelector('[data-xcf-sort-form]');
    if(root.dataset.filterEnabled!=='true'){sort.addEventListener('change',()=>sortForm.submit());return;}
    const controls=root.querySelector('.xcf-controls'),input=root.querySelector('[data-xcf-search]'),fieldset=root.querySelector('[data-xcf-colours]'),grid=root.querySelector('[data-xcf-grid]'),active=root.querySelector('[data-xcf-active]'),counter=root.querySelector('[data-xcf-count]'),pages=root.querySelector('[data-xcf-pages]'),nativePages=root.querySelector('[data-xcf-native-pages]'),status=root.querySelector('[data-xcf-status]'),retry=root.querySelector('[data-xcf-retry]'),empty=root.querySelector('[data-xcf-empty]');
    const decode=value=>{const node=document.createElement('textarea');node.innerHTML=value;return node.value;};
    const labels=Object.fromEntries(Object.entries(JSON.parse(root.querySelector('[data-xcf-labels]').textContent)).map(([key,value])=>[key,decode(value)]));
    const buttons=[...root.querySelectorAll('[data-xcf-colour]')],families=Object.fromEntries(buttons.map(button=>[button.dataset.xcfColour,decode(button.dataset.label)]));
    const allowedSort=new Set([...sort.options].map(option=>option.value)),pageSize=Number(root.dataset.pageSize)||24;
    const cache=new Map();let entries=[],loaded=false,loadingSort='',revision=0,timer;
    const initial={query:'',colours:[],sort:sort.value,page:1};let state={...initial};
    const countLabel=n=>n===1?labels.piece:labels.pieces.replace('__count__',String(n));
    function readState(){const params=new URL(location.href).searchParams;const sortValue=params.get('sort_by')||root.dataset.defaultSort;return{query:(params.get('xwp_q')||'').slice(0,120),colours:[...new Set((params.get('xwp_colour')||'').split(',').filter(c=>families[c]))],sort:allowedSort.has(sortValue)?sortValue:initial.sort,page:Math.max(1,Math.floor(Number(params.get('xwp_page')||params.get('page'))||1))};}
    function stateUrl(target=location.href,page=state.page){const url=new URL(target,location.origin);['xwp_q','xwp_colour','xwp_page','page'].forEach(key=>url.searchParams.delete(key));if(state.query.trim())url.searchParams.set('xwp_q',state.query.trim());if(state.colours.length)url.searchParams.set('xwp_colour',state.colours.join(','));if(state.sort!==root.dataset.defaultSort)url.searchParams.set('sort_by',state.sort);else url.searchParams.delete('sort_by');if(page>1)url.searchParams.set('xwp_page',String(page));const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url;}
    function syncUrl(mode='replace'){const url=stateUrl();if(url.href!==location.href)history[mode==='push'?'pushState':'replaceState']({},'',url);root.querySelectorAll('.xcf-categories a').forEach(a=>{a.href=stateUrl(a.href,1).href;});}
    async function catalogue(sortValue){
      if(cache.has(sortValue))return cache.get(sortValue);
      const request=(async()=>{
        const first=new URL(root.dataset.collectionUrl,location.origin);first.searchParams.set('section_id','xwp-collection-catalog');first.searchParams.set('sort_by',sortValue);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)first.searchParams.set('preview_theme_id',preview);
        const result=new Map(),seen=new Set();let next=first,total;
        while(next){
          if(next.origin!==first.origin||next.pathname!==first.pathname||seen.has(next.href)||seen.size>=100)throw Error('Invalid catalogue pagination');
          seen.add(next.href);const response=await fetch(next,{headers:{Accept:'text/html'}});if(!response.ok)throw Error('Catalogue unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html'),body=doc.querySelector('[data-xwp-collection-catalog]');if(!body)throw Error('Catalogue missing');
          if(total===undefined)total=Number(body.dataset.total);
          if(Number(body.dataset.total)!==total)throw Error('Catalogue changed during loading');
          body.querySelectorAll('template[data-xcf-item]').forEach(template=>{const data=template.dataset;result.set(data.handle,{handle:data.handle,text:normalise(data.search),colours:(data.colours||'').split(',').filter(Boolean),template});});
          const link=body.querySelector('[data-xcf-next]');next=link?new URL(link.getAttribute('href'),first):null;if(next){next.searchParams.set('section_id','xwp-collection-catalog');next.searchParams.set('sort_by',sortValue);if(preview)next.searchParams.set('preview_theme_id',preview);}
        }
        if(result.size!==total)throw Error('Incomplete catalogue');return[...result.values()];
      })();
      cache.set(sortValue,request);try{return await request;}catch(error){cache.delete(sortValue);throw error;}
    }
    function render(){
      input.value=state.query;sort.value=state.sort;root.querySelector('[data-xcf-clear-search]').hidden=!state.query;
      root.querySelector('[data-xcf-selected]').textContent=state.colours.length?labels.selected.replace('__count__',state.colours.length):labels.choose;
      const tokens=normalise(state.query).match(/[\p{L}\p{N}]+/gu)||[];
      const base=entries.filter(entry=>tokens.every(token=>`${entry.text} ${entry.colours.map(c=>normalise(families[c])).join(' ')}`.includes(token)));
      const results=base.filter(entry=>!state.colours.length||entry.colours.some(c=>state.colours.includes(c)));
      buttons.forEach(button=>{const family=button.dataset.xcfColour,selected=state.colours.includes(family),count=base.filter(entry=>entry.colours.includes(family)).length;button.setAttribute('aria-pressed',String(selected));button.setAttribute('aria-label',`${families[family]}, ${countLabel(count)}`);button.disabled=loaded&&!count&&!selected;button.querySelector('[data-xcf-colour-count]').textContent=loaded?String(count):'';});
      const chips=[];if(state.query)chips.push({id:'query',label:`“${state.query}”`});state.colours.forEach(id=>chips.push({id,label:families[id]}));
      active.hidden=!chips.length;active.innerHTML=chips.map(({id,label})=>`<button type="button" class="xcf-chip" data-xcf-remove="${id}" aria-label="${escape(labels.remove.replace('__filter__',label))}"><span>${escape(label)}</span><span aria-hidden="true">×</span></button>`).join('')+(chips.length?`<button type="button" class="xcf-reset" data-xcf-reset>${escape(labels.clear)}</button>`:'');
      if(!loaded)return;
      const pageCount=Math.max(1,Math.ceil(results.length/pageSize));state.page=Math.min(state.page,pageCount);
      const fragment=document.createDocumentFragment();results.slice((state.page-1)*pageSize,state.page*pageSize).forEach(entry=>fragment.append(entry.template.content.cloneNode(true)));grid.replaceChildren(fragment);grid.dispatchEvent(new CustomEvent('xwp:products:rendered',{bubbles:true}));
      counter.textContent=countLabel(results.length);empty.hidden=!!results.length;nativePages.hidden=true;pages.hidden=pageCount<=1;
      const link=(page,label,current=false)=>`<a href="${escape(stateUrl(location.href,page))}" data-xcf-page="${page}" aria-label="${escape(/^\d+$/.test(label)?labels.page_label.replace('__page__',page):label)}"${current?' aria-current="page"':''}>${escape(label)}</a>`;
      const numbers=[...new Set([1,state.page-1,state.page,state.page+1,pageCount])].filter(n=>n>0&&n<=pageCount).sort((a,b)=>a-b);
      const pagination=[];if(state.page>1)pagination.push(link(state.page-1,labels.previous));numbers.forEach((page,index)=>{if(index&&page-numbers[index-1]>1)pagination.push('<span aria-hidden="true">…</span>');pagination.push(link(page,String(page),page===state.page));});if(state.page<pageCount)pagination.push(link(state.page+1,labels.next));pages.innerHTML=pagination.join('');
      pages.setAttribute('aria-label',labels.page.replace('__page__',state.page).replace('__pages__',pageCount));
    }
    async function load(){
      const version=++revision;loaded=false;loadingSort=state.sort;fieldset.disabled=true;status.hidden=false;status.textContent=labels.loading;retry.hidden=true;root.setAttribute('aria-busy','true');
      try{const records=await catalogue(state.sort);if(version!==revision||!root.isConnected)return;entries=records;loaded=true;fieldset.disabled=false;status.hidden=true;root.dataset.xcfCount=String(entries.length);root.dataset.xcfLoadedSort=state.sort;render();syncUrl();}
      catch{if(version===revision){status.textContent=labels.error;retry.hidden=false;}}
      finally{if(version===revision)root.removeAttribute('aria-busy');}
    }
    function reset(){clearTimeout(timer);state.query='';state.colours=[];state.page=1;render();syncUrl('push');input.focus();}
    controls.hidden=false;state=readState();render();syncUrl();void load();
    root.querySelector('.xcf-search').addEventListener('submit',event=>{event.preventDefault();clearTimeout(timer);state.query=input.value;state.page=1;render();syncUrl();});
    input.addEventListener('input',()=>{clearTimeout(timer);state.query=input.value;state.page=1;timer=setTimeout(()=>{render();syncUrl();},180);});
    root.querySelector('[data-xcf-clear-search]').addEventListener('click',()=>{clearTimeout(timer);state.query='';state.page=1;render();syncUrl('push');input.focus();});
    fieldset.addEventListener('click',event=>{const button=event.target.closest('[data-xcf-colour]');if(!button||button.disabled)return;const family=button.dataset.xcfColour;state.colours=state.colours.includes(family)?state.colours.filter(c=>c!==family):[...state.colours,family];state.page=1;render();syncUrl('push');});
    root.addEventListener('click',event=>{const remove=event.target.closest('[data-xcf-remove]');if(remove){if(remove.dataset.xcfRemove==='query')state.query='';else state.colours=state.colours.filter(c=>c!==remove.dataset.xcfRemove);state.page=1;render();syncUrl('push');}else if(event.target.closest('[data-xcf-reset]'))reset();});
    sort.addEventListener('change',()=>{state.sort=sort.value;state.page=1;syncUrl('push');void load();});sortForm.addEventListener('submit',event=>{event.preventDefault();state.sort=sort.value;state.page=1;syncUrl('push');void load();});
    pages.addEventListener('click',event=>{const link=event.target.closest('[data-xcf-page]');if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();state.page=Number(link.dataset.xcfPage);render();syncUrl('push');root.querySelector('.xcf-results-head').scrollIntoView({block:'start',behavior:'instant'});pages.querySelector('[aria-current=page]')?.focus({preventScroll:true});});
    retry.addEventListener('click',()=>void load());
    window.addEventListener('popstate',()=>{if(!root.isConnected)return;const next=readState(),sortChanged=next.sort!==loadingSort;state=next;if(sortChanged)loaded=false;render();syncUrl();if(sortChanged||!loaded)void load();});
  }
  const init=()=>document.querySelectorAll('[data-xwp-collection]').forEach(start);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
